import { ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useForm, useField } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import { loginSchema, activateSchema, forgotPasswordSchema, resetPasswordSchema } from '@/schemas/authSchema'

export const useAuthForm = (formType: 'login' | 'activate' | 'forgotPassword' | 'resetPassword') => {
  const toast = useToast()
  const loading = ref(false)

  let schema;
  switch (formType) {
    case 'login':
      schema = loginSchema;
      break;
    case 'activate':
      schema = activateSchema;
      break;
    case 'forgotPassword':
      schema = forgotPasswordSchema;
      break;
    case 'resetPassword':
      schema = resetPasswordSchema;
      break;
  }

  const { handleSubmit, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(schema)
  })

  const { value: email, errorMessage: emailError } = useField<string>('email')
  const { value: password, errorMessage: passwordError } = useField<string>('password')
  const { value: confirmPassword, errorMessage: confirmPasswordError } = useField<string>('confirmPassword')
  const { value: token, errorMessage: tokenError } = useField<string>('token')

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  return {
    email,
    password,
    confirmPassword,
    token,
    handleSubmit,
    setErrors,
    resetForm,
    meta,
    loading,
    showToast,
    formType,
    errors: {
      email: emailError,
      password: passwordError,
      confirmPassword: confirmPasswordError,
      token: tokenError
    },
  }
}